import SectionMixin from '@/mixins/sectionMixin'


export default {
    name: 'feature-full-video-block',
    mixins: [SectionMixin],
    components: {
    },
    props: {
        videoId: String,
    },
    data: () => {
        return {
            isIntersecting: false,
            visible: false,
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        show() {
            if (this.visible) {
                return
            }
            this.visible = true
        },
    }
}